<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="nivel-educativo-formulario" titulo="Formulario / Configuración" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <a id="catalogos" (click)="ctrl.cargarCatalogo('niveles_eduactivos', 'nivel-educativo', 'crear_form'); ctrl.cargarCatalogo('formularios', 'configuracion-formulario');"></a>
            <a id="crear_form" (click)="agregar_niveles(ctrl.niveles_eduactivos);"></a>
            <!-- formulario -->
            <form name="form" [formGroup]="dato" novalidate (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section formGroupName="niveles_educativos_formularios" class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                  <fieldset>
                    <legend>Formularios para preinscripcion por nivel educativo</legend>
                    <table class="table is-striped  is-fullwidth" formArrayName="preinscripcion">
                      <thead>
                        <tr>
                          <th width="10%"><abbr>ID</abbr></th>
                          <th width="45%">Nivel educativo</th>
                          <th width="45%">Formulario de preinscripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ctrl.dato.controls.niveles_educativos_formularios.controls.preinscripcion.controls; let i=index" [formGroupName]="i">
                          <th style="vertical-align: middle;">{{ i + 1 }}</th>
                          <td style="vertical-align: middle;">{{ item.value.niveles_educativos.nombre }} </td>
                          <td style="vertical-align: middle;">
                            <div class="control has-icons-left has-icons-right">
                              <ng-select2 [disabled]="ctrl.formularios ? ctrl.formularios.length == 0 ? true : false : true" name="formularios_id" [options]="ctrl.optionSelect" [value]="item.controls.formularios_id.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, item.controls.formularios_id);"
                                [data]="ctrl.formularios"></ng-select2>
                              <span class="icon is-small is-right" *ngIf="item.controls.formularios_id.hasError('required') ">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="item.controls.formularios_id.hasError('required') ">Este campo es requerido.</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>

                  <fieldset>
                    <legend>Formularios para alumnos por nivel educativo</legend>
                    <table class="table is-striped  is-fullwidth" formArrayName="alumno">
                      <thead>
                        <tr>
                          <th width="10%"><abbr>ID</abbr></th>
                          <th width="45%">Nivel educativo</th>
                          <th width="45%">Formulario para alumno</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ctrl.dato.controls.niveles_educativos_formularios.controls.alumno.controls; let i=index" [formGroupName]="i">
                          <th style="vertical-align: middle;">{{ i + 1 }}</th>
                          <td style="vertical-align: middle;">{{ item.value.niveles_educativos.nombre }} </td>
                          <td style="vertical-align: middle;">
                            <div class="control has-icons-left has-icons-right">
                              <ng-select2 [disabled]="ctrl.formularios ? ctrl.formularios.length == 0 ? true : false : true" name="formularios_id" [options]="ctrl.optionSelect" [value]="item.controls.formularios_id.value"
                                (valueChanged)="ctrl.seleccionarValorSelect2($event, item.controls.formularios_id);" [data]="ctrl.formularios"></ng-select2>
                              <span class="icon is-small is-right" *ngIf="item.controls.formularios_id.hasError('required') ">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="item.controls.formularios_id.hasError('required') ">Este campo es
                                requerido.</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>

                </section>
            </form>
        </div>
    </div>
</div>

